export const current_location = {
	name: 'current-location',
	title: 'Current Location',
	content: `
	<circle
		cx="12"
		cy="12"
		r="3"
		stroke="currentColor"
		fill="none"
		stroke-width=".5"
		stroke-linecap="round"
		stroke-linejoin="round" />
	<path
		d="M13 4.069V2h-2v2.069A8.01 8.01 0 0 0 4.069 11H2v2h2.069A8.008 8.008 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"
		stroke="currentColor"
		fill="none"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round" />
	`,
};
